import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, InfiniteTable, DLMenu } from 'appSrc/components/UI';
import EditProfessionModal from '../../Modals/Profession/EditProfessionModal';
import style from './styles/style.module.css';

class InfiniteProfessionsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            professionInEdit: null,
            professionInEditIndex: -1,
        };
    }
    updateProfession = ( index, id, data ) => {
        this.props.updateProfession( id, data )
        .then( ( profession ) => {
            return this.props.onProfessionUpdated && this.props.onProfessionUpdated( index, profession );
        } );
    }
    openEditModal = ( index, profession ) => {
        this.setState( { professionInEdit: profession, professionInEditIndex: index } );
    }
    onEditSubmit = ( profession ) => {
        var index = this.state.professionInEditIndex;
        this.props.onProfessionUpdated( index, profession );
        this.setState( { professionInEdit: null, professionInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { professionInEdit: null, professionInEditIndex: -1 } );
    }



    render() {
        const { professions } = this.props;
        const { professionInEdit } = this.state;

        return (
            <div>
                <InfiniteTable
                className={ style.professionsTable }
                elementHeight={ 90 }>
                    { this.arrayTableRows( professions ) }
                </InfiniteTable>
                { professionInEdit !== null &&
                    <EditProfessionModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    profession={ professionInEdit } />
                }
            </div>
        );
    }

    arrayTableRows = ( professions ) => {
        var rows = professions.map( ( profession, index ) => {
            return (
                <InfiniteTable.Row key={ profession.id } className='dl-table-body'>
                    <InfiniteTable.Cell className={ style.professiontext }>
                        { profession.title }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, profession );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell>
                    PROFESSION { sortIcon( 'professions.title,professions.id' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell className={ style.actionsCell }>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}
InfiniteProfessionsTable.defaultProps = {
    onProfessionUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateProfession: ( id, data ) => {
            return dAPI.patch( `/interests/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( InfiniteProfessionsTable );
